import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import ReviewSettings from 'modules/reviews/components/ReviewSettings/Settings'
import ReviewShowWrapper from 'modules/reviews/components/Show/ReviewShowWrapper'
import { useReviewShowContext } from 'modules/reviews/pages/performance/Show/hooks'

export default function ReviewConfigurationPage() {
  const { canEditReview, review } = useReviewShowContext()
  const authorizeFn = (): boolean => canEditReview

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (loading) return <Loading />

  return (
    <AuthorizeUser authorizeFn={authorizeFn}>
      <ReviewShowWrapper reviewId={Number(review.attributes.id)}>
        <ReviewSettings contractVersions={contractVersions} />
      </ReviewShowWrapper>
    </AuthorizeUser>
  )
}
